import { ObservationEntity } from '../../../coaching-base/config';
import { CoachingTranscript } from '../../../coaching-base/general';
import { BehaviourItem } from '../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../coaching-tags/models/subbehaviour.coaching.model';
import { Platform } from '../../../platform-call';
import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

export interface Reload {
    platform: Platform;
    transcriptId: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_DETAIL__TD__RELOAD,
);

export interface ReloadResult extends Reload {
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    observationConfig?: ObservationEntity;
    transcript?: CoachingTranscript;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING_DETAIL__TD__RELOAD_RESULT,
);
